import React from 'react';
import { QCenter, QSpinner } from '@qualio/ui-components';
import { useParams } from 'react-router-dom';
import { useTemplate } from '../../hooks/useTemplate';
import { TemplateDetails } from '../../components/TemplateDetails/TemplateDetails';
import { useTemplateVersions } from '../../hooks/useTemplateVersions';

const TemplateDetailView: React.FC = () => {
  const { templateId } = useParams();
  const { data: templateDetail, isLoading: isApiLoading, isLoadingError } = useTemplate(templateId);
  const { data: templateVersions, isLoading: isTemplateVersionsLoading } = useTemplateVersions(
    templateDetail?.template_uuid,
  );
  const isLoading =
    isApiLoading || isTemplateVersionsLoading || templateDetail === undefined || templateVersions === undefined;

  if (isLoadingError) {
    window.location.href = '/404';
  }

  if (isLoading) {
    return (
      <QCenter data-cy="loading-spinner">
        <QSpinner role={'spinner'} />
      </QCenter>
    );
  }

  return <TemplateDetails data={templateDetail} versions={templateVersions} />;
};

export default TemplateDetailView;
